import axios from '@/common/http2.js';
import { setStoreData } from '@/common/tolls.js'
import {  Message } from 'element-ui'
import store from '@/store/index.js';
const deblug = true; //开启作物提示
// 对象数组根据属性分组
 function groupBy(array, f) {
        var groups = {};
        array.forEach(function (o) {
            var group = JSON.stringify(f(o));
            groups[group] = groups[group] || [];
            groups[group].push(o);
        });
        return Object.keys(groups).map(function (group) {
            return groups[group];
        });
    }
    // 时间格式转换
function timeConvert(timestamp, num) {
    	//num:0 YYYY-MM-DD  num:1  YYYY-MM-DD hh:mm:ss // timestamp:时间戳
    	timestamp = timestamp + '';
    	timestamp = timestamp.length == 10 ? timestamp * 1000 : timestamp;
    	var date = new Date(timestamp);
    	var y = date.getFullYear();
    	var m = date.getMonth() + 1;
    	m = m < 10 ? ('0' + m) : m;
    	var d = date.getDate();
    	d = d < 10 ? ('0' + d) : d;
    	var h = date.getHours();
    	h = h < 10 ? ('0' + h) : h;
    	var minute = date.getMinutes();
    	var second = date.getSeconds();
    	minute = minute < 10 ? ('0' + minute) : minute;
    	second = second < 10 ? ('0' + second) : second;
    	if (num == 0) {
    		return m + '-' + d + ' ' + h + ':' + minute;
    	}else if(num == 1){
    		return y + '-' + m + '-' + d
    	}else {
    		return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second;
    	}
    }
// 区间数组获取
function groupsection(array){
  let sectionarr = [];
  for(let i=0; i<arr.length; i++){
    sectionarr.push(array[i].from+"-"+array[i].to)
  }
  return sectionarr
}
var action = {
  //考试信息
async getTaskInfo({commit,state,getters},{}={}){
  let params;
  if(state.nowsubject !='全科'){
    params={
      item_id:state.projectid,
      school_name:state.schoolname,
      exam_id:state.examid

    }
  }else{
    params={
      item_id:state.projectid,
      school_name:state.schoolname,
    }
  }
    axios.$req({
      url:'index/stat.Teachana/getTaskInfo',
      method:'post',
      params:params,
      success({data}){
        data[0].time = timeConvert(data[0].exam_time,1)
        commit("setData",{
        	data: data[0],
        	field: 'examinfo'
        });
      }
    })
  },
async getgrade({commit,state,getters},{}={}){
    axios.$req({
      url:'/newksapp/system/system/getGradeList',
      method:'get',
      success(res){
        commit("setData",{
        	data: res.data,
        	field: 'gradearr'
        });
      }
    })
  },
  // 总成绩
 getscroe({ commit, state, getters }) {
 	var request_url = `/index/stat.Teachana/getMultipleScore`;
 	axios.$req({
 		url: `${request_url}`,
    method:'GET',
    params:{
      item_id:state.projectid,
      school_name:state.schoolname,
      exam_id:state.examid
    },
 		success({data}) {
      commit("setData",{
      	data: data,
      	field:'allscroe'
      });
 		},
 		fail({message}){
      if(deblug) return
       Message({
            message:'总成绩'+message,
            type: 'error'
          })
 		}
 	});
 },
 // 四率统计
 async getStatistics({ commit, state, getters },{classname}={}) {
 	var request_url = `/index/stat.Teachana/classAllRate`;
  let params;
  let classlist = state.calsslist.join(',')
  if(state.nowsubject == '全科'){
    params={
      item_id:state.projectid,
      school_name:state.schoolname,
      class:classlist
      // exam_id
    }
  }else{
    params={
      item_id:state.projectid,
      school_name:state.schoolname,
      class:classlist,
      exam_id:state.examid
    }
  }

 	axios.$req({
 		url: `${request_url}`,
    method:'POST',
    params:params,
 		success({data,info}) {
      ////console.log(data,info)
      commit("setData",{
      	data: data,
      	field: 'Statistics'
      });
      info[0].ex_rate = info[0].ex_rate.toFixed(2);
      info[0].nor_rate = info[0].nor_rate.toFixed(2);
      commit("setData",{
      	data: info[0],
      	field: 'StatisticsTitle'
      });
 		},
 		fail({message}){
      if(deblug) return
       Message({
            message:'四率'+message,
            type: 'error'
          })
 		}
 	});
 },
 // 各班排名与上次的对比
 async getranking({ commit, state, getters }) {
 	var request_url = `/index/stat.Teachana/getRankCompare`;
 	axios.$req({
 		url: `${request_url}`,
    method:'POST',
    params:{
      item_id:state.projectid,
      school_name:state.schoolname,
      // exam_id
    },
 		success({data}) {
     if(data[0].class ==data[1].class){

     }else{
       commit("setData",{
       	data: data,
       	field: 'ranking'
       });
     }

 		},
 		fail({message}){
      if(deblug) return
       Message({
            message:'各班排名与上次的对比'+message,
            type: 'error'
       })
 		}
 	});
 },
 // 成绩分段统计全科  //分段
 async getsubsection({ commit, state, getters },{classname}={}) {
 	var request_url;
   let params;
   if(state.nowsubject == '全科'){
     //console.log(111,state.subsectionclass)
     request_url = `/index/stat.Teachana/teachAllSection`;
     params={
       item_id:state.projectid,
       school_name:state.schoolname,
       class:classname || state.subsectionclass,
       hscore:'800',
       lscore:'0',
       compare_score:'50'
     }
   }else{
      //console.log(222)
      request_url = `/index/stat.Teachana/teachAllSection`;
      params={
        item_id:state.projectid,
        school_name:state.schoolname,
        class:classname || state.subsectionclass,
        hscore:'100',
        lscore:'0',
        compare_score:'10',
        exam_id:state.examid
      }
   }
 	axios.$req({
 		url: `${request_url}`,
     method:'POST',
    params:params,
 		success({data}) {
      commit("setData",{
      	data: data,
      	field: 'subsectionall'
      });

 		},
 		fail({message}){
      if(deblug) return
       Message({
            message:'成绩分段统计全科'+message,
            type: 'error'
       })
 		}
 	});
 },
 // 分段统计
 async geteachAllSection({ commit, state, getters },{classname,hscore,lscore,comparescore}={}) {
    let request_url = `/index/stat.Teachana/teachAllSection2`;

 	axios.$req({
 		url: `${request_url}`,
     method:'POST',
    params:{
      item_id:state.projectid,
      school_name:state.schoolname,
      class:classname.join(',') || state.calsslist.join(','),
      hscore:hscore,
      lscore:lscore,
      compare_score:comparescore,
      exam_id:state.examid
    },
 		success({data}) {
      commit("setData",{
      	data: data,
      	field: 'segment'
      });
      //////console.log(data)
      if(data!=''){
        let datasd = data
        let arr=['1','2']
        for(let i in datasd){
          if(i !='class' && i!='people'){
            arr.push(Math.max.apply(null, datasd[i]))
            //////console.log(Math.max.apply(null, data[i]))
          }
        }
        commit("setData",{
        	data: arr,
        	field: 'segmentmax'
        });
      }
 		},
 		fail({message}){
      if(deblug) return
       Message({
            message:'分段统计'+message,
            type: 'error'
       })
 		}
 	});
 },
 // 丢分最高的题
 async getAnalyLose({ commit, state, getters },{classname}={}) {
 	var request_url = `/index/stat.Teachana/teachAnalyLose`;
 	axios.$req({
 		url: `${request_url}`,
     method:'POST',
    params:{
      item_id:state.projectid,
      school_name:state.schoolname,
      class:classname || state.nowclass,
      exam_id:state.examid
    },
 		success({data}) {
      if(data.length !=0){
        for(let i=0; i<data.length; i++){
           data[i].class_lose = (data[i].class_lose*100).toFixed(2)+'%';
           data[i].school_lose = (data[i].school_lose*100).toFixed(2)+'%';
           if(data[i].datika_num.substring(1,0) =='客' ){
              data[i].type = 1;
           }else{
              data[i].type = 2;
           }
        }
      }
     commit("setData",{
     	data:data,
     	field: 'Losetimu'
     });
 		},
 		fail({message}){
      if(deblug) return
       Message({
            message:'丢分最高的题'+message,
            type: 'error'
       })
 		}
 	});
 },
 // 丢分最多的知识点classnamegetAnalyPoint
 async getAnalyPoint({ commit, state, getters },{classname}={}) {
 	var request_url = `/index/stat.Teachana/teachAnalyPoint`;
 	axios.$req({
 		url: `${request_url}`,
     method:'POST',
    params:{
      item_id:state.projectid,
      school_name:state.schoolname,
      class:classname || state.nowclass,
      exam_id:state.examid,
    },
 		success({data}) {
      if(data.length !=0){
        for(let i=0; i<data.length; i++){
           data[i].class_lose = (data[i].class_lose*100).toFixed(2)+'%' ;

        }
      }

     commit("setData",{
     	data:data,
     	field: 'Losezsd'
     });
 		},
 		fail({message}){
      if(deblug) return
       Message({
            message:'丢分最多的知识点'+message,
            type: 'error'
       })
 		}
 	});
 },
 // 丢分最多的知识点classnamegetAnalyPoint
 async getAnalyPointes({ commit, state, getters },{classname,page,size}={}) {
 	var request_url = `/index/stat.Teachana/teachAnalyPoint`;
 	axios.$req({
 		url: `${request_url}`,
     method:'POST',
    params:{
      item_id:state.projectid,
      school_name:state.schoolname,
      class:classname || state.nowclass,
      exam_id:state.examid,
      page:page,
      size:size
    },
 		success({data}) {
      if(data.length>0){
        for(let i=0; i<data.length; i++){
          if(data[i].timu_id.indexOf(',')!=-1){
            data[i].timu_id = data[i].timu_id.split(',')
          }else{
            data[i].timu_id = data[i].timu_id.split()
          }

        }
      }
     commit("setData",{
     	data:data,
     	field: 'Losezsdes'
     });
 		},
 		fail({message}){
      if(deblug) return
       Message({
            message:'丢分最多的知识点'+message,
            type: 'error'
       })
 		}
 	});
 },

 // 重要数据统计
 //上线成员列表/index/stat.Teachana/teachClassClear
 async getteachSingleCount({ commit, state, getters },{classname,hscore1,lscore1,hscore2,lscore2}={}) {
 	var request_url
  let params;
  if(state.nowsubject =='全科'){
    request_url = `/index/stat.Teachana/teachClassClear`
   params={
     item_id:state.projectid,
     school_name:state.schoolname,
     class:classname.join(','),
     hscore:hscore1,
     lscore:lscore1
   }
  }else{
   request_url  = `/index/stat.Teachana/teachSubjectClear`;
    params={
      item_id:state.projectid,
      school_name:state.schoolname,
      class:classname.join(','),
      exam_id:state.examid,
      hscore1:hscore1,
      lscore1:lscore1,
      hscore2:hscore2,
      lscore2:lscore2
    }
  }
 	axios.$req({
 		url: `${request_url}`,
     method:'POST',
    params:params,
 		success({data}) {
     commit("setData",{
     	data:data,
     	field: 'Singlsit'
     });
 		},
 		fail({message}){
      if(deblug) return
       Message({
            message:'上线成员列表'+message,
            type: 'error'
       })
 		}
 	});
 },
 // 总分上线
 async teachClassCountall({ commit, state, getters },{classname,hscore,lscore}={}) {
 	var request_url = `/index/stat.Teachana/teachClassCount`;
 	axios.$req({
 		url: `${request_url}`,
     method:'POST',
    params:{
      item_id:state.projectid,
      school_name:state.schoolname,
      class:classname.join(','),
      hscore:hscore,
      lscore:lscore
    },
 		success({data}) {
     commit("setData",{
     	data:data,
     	field: 'SingleCountall'
     });
 		},
 		fail({message}){
      if(deblug) return
       Message({
            message:'总分上线'+message,
            type: 'error'
       })
 		}
 	});
 },
 //单科上线人数
 async teachSingleCount({ commit, state, getters },{classname,hscore,lscore}={}) {
 	var request_url = `/index/stat.Teachana/teachSingleCount`;
 	axios.$req({
 		url: `${request_url}`,
     method:'POST',
    params:{
      item_id:state.projectid,
      school_name:state.schoolname,
      class:classname.join(','),
      hscore:hscore,
      lscore:lscore,
      exam_id:state.examid,
    },
 		success({data}) {
     commit("setData",{
     	data:data,
     	field: 'SingleCount'
     });
 		},
 		fail({message}){
      if(deblug) return
       Message({
            message:'单科上线人数'+message,
            type: 'error'
       })
 		}
 	});
 },

// 临界生全科
async getAllCritical({ commit, state, getters},{criticalvalue,score}={}){
  axios.$req({
    url:'index/stat.Teachana/getAllCritical',
    method:'post',
    params:{
     item_id:state.projectid,
     school_name:state.schoolname,
     score:score,
     critical_value:criticalvalue,
     class:state.calsslist.join(','),
    },
    success({data}){
      console.log('误啥')
      if(data.length>0){
        commit("setData",{
        	data:data,
        	field: 'Critical'
        })
        let up=[],down=[];
        for(let i=0; i<data.length; i++){
          ////////console.log(data[i].Critical>=0)
          if(data[i].Critical>=0){
            up.push(data[i])
          }else{
            down.push(data[i])
          }
        }
        console.log(data)
        commit("setData",{
        	data:up,
        	field: 'Criticalup'
        });
        commit("setData",{
        	data:down,
        	field: 'Criticaldown'
        });
      }else{
        ////////console.log(data,'wu1')
        commit("setData",{
        	data:'empty',
        	field: 'Criticalup'
        });
        commit("setData",{
        	data:'empty',
        	field: 'Criticaldown'
        });
        commit("setData",{
        	data:'empty',
        	field: 'Critical'
        });
      }

    },
 		fail({message}){
      if(deblug) return
       Message({
            message:'临界生全科'+message,
            type: 'error'
       })
 		}
  })
},
// 临界生单科
async getSingleCritical({ commit, state, getters},{criticalvalue,score,singlevalue}={}){
  axios.$req({
    url:'index/stat.Teachana/getSingleCritical',
    method:'post',
    params:{
     item_id:state.projectid,
     school_name:state.schoolname,
     score:score,
     critical_value:criticalvalue,
     class:state.calsslist.join(','),
     exam_id:state.examid,
     single_value:singlevalue
    },
    success({data}){
      ////////console.log(data,'临界值')
      if(data.length>0){
        commit("setData",{
        	data:data,
        	field: 'Critical'
        })
        let up=[],down=[];
        for(let i=0; i<data.length; i++){
          ////////console.log(data[i].Critical>=0)
          if(data[i].Critical>=0){
            up.push(data[i])
          }else{
            down.push(data[i])
          }
        }
        commit("setData",{
        	data:up,
        	field: 'Criticalup'
        });
        commit("setData",{
        	data:down,
        	field: 'Criticaldown'
        });
      }else{
       commit("setData",{
       	data:'empty',
       	field: 'Criticalup'
       });
       commit("setData",{
       	data:'empty',
       	field: 'Criticaldown'
       });
       commit("setData",{
       	data:'empty',
       	field: 'Critical'
       });
      }
    },
 		fail({message}){
      if(deblug) return
       Message({
            message:'临界生单科'+message,
            type: 'error'
       })
 		}
  })
},
// 命中率 贡献率 第一段
async getOneRatio({ commit, state, getters},{hscore,lscore} = {}){
  axios.$req({
    url:'index/stat.Teachana/getOneRatio',
    method:'post',
    params:{
     item_id:state.projectid,
     school_name:state.schoolname,
     hscore:hscore,
     lscore:lscore,
     exam_id:state.examid
    },
    success({data}){
      ////////console.log(data)
      if(data.length>0){
        if(JSON.stringify(data[0].gongxian).indexOf('.') !=-1){
          data[0].gongxian = data[0].gongxian.toFixed(2)
        }
        if(JSON.stringify(data[0].mingzhong).indexOf('.') !=-1){
         data[0].mingzhong = data[0].mingzhong.toFixed(2)
        }
        commit("setData",{
        	data:data[0],
        	field: 'oneRatio'
        });
      }else{
        commit("setData",{
        	data:'empty',
        	field: 'oneRatio'
        });
      }
},
 		fail({message}){
      if(deblug) return
       Message({
            message:'命中率一'+message,
            type: 'error'
       })
 		}
})
},
// 命中率 贡献率 第二段
async getTwoRatio({ commit, state, getters},{hscore,lscore} = {}){
  axios.$req({
    url:'index/stat.Teachana/getTwoRatio',
    method:'post',
    params:{
     item_id:state.projectid,
     school_name:state.schoolname,
     hscore:hscore,
     lscore:lscore,
     exam_id:state.examid
    },
    success({data}){
     if(data.length>0){
       if(JSON.stringify(data[0].gongxian).indexOf('.') !=-1){
         data[0].gongxian = data[0].gongxian.toFixed(2)
       }
       if(JSON.stringify(data[0].mingzhong).indexOf('.') !=-1){
        data[0].mingzhong = data[0].mingzhong.toFixed(2)
       }
       commit("setData",{
       	data:data[0],
       	field: 'twoRatio'
       });
     }else{
       commit("setData",{
       	data:'empty',
       	field: 'twoRatio'
       });
     }
},
 		fail({message}){
      if(deblug) return
       Message({
            message:'命中率'+message,
            type: 'error'
       })
 		}
})
},


//学生成绩排名index/stat.Teachana/getSingleRank
async getSingleRank({ commit, state, getters},{classname} = {}){
 let params;
 let request_url;
 if(state.nowsubject != '全科'){
  request_url = 'index/stat.Teachana/getSingleRank';
   params={
     item_id:state.projectid,
     school_name:state.schoolname,
     class:classname.join(','),
     exam_id:state.examid,
     page:state.rnkp,
     size:state.rnks,
    }
 }else{
   request_url = 'index/stat.Teachana/getALLRank';
   params={
     item_id:state.projectid,
     school_name:state.schoolname,
     class:classname.join(','),
     page:state.rnkp,
     size:state.rnks
    }
 }
  axios.$req({
    url:request_url,
    method:'post',
    params:params,
    success({data,info}){
      if(data.length>0){
       commit("setData",{
       	data:data,
       	field: 'SingleRank'
       });
       commit("setData",{
       	data:info,
       	field: 'rnktotal'
       });

     }else{
       commit("setData",{
       	data:'empty',
       	field: 'SingleRank'
       });
     }
},
 		fail({message}){
      if(deblug) return
       Message({
            message:'学生成绩排名'+message,
            type: 'error'
       })
 		}
})
},

//试题平均分
async allRankAvg({ commit, state, getters},{classname,examid} = {}){
  let examids;
  if(state.nowsubject !='全科'){
    examids=examid || state.examid
  }else{

  }
  axios.$req({
    url:'index/stat.Teachana/allRankAvg',
    method:'post',
    params:{
     item_id:state.projectid,
     school_name:state.schoolname,
     class:classname.join(',') || state.calsslist.join(','),
     exam_id:examids,
    },
    success({data}){
      // //////console.log(data)
      let dataes = JSON.parse(JSON.stringify(data))
     let arr=[];
      for(let i in dataes){
          for(let j=0; j<dataes[i].length; j++){
            var index=dataes[i][j].lastIndexOf("/");
             dataes[i][j]=dataes[i][j].substring(0,index);
          }
      }
      for(let i in dataes){
         arr.push(Math.max.apply(null,dataes[i]))
      }
      //////console.log(arr)
      commit("setData",{
      	data:arr,
      	field: 'maxnum'
      });
      commit("setData",{
      	data:data,
      	field: 'avglist'
      });

   },
 		fail({message}){
      if(deblug) return
       Message({
            message:'试题平均分'+message,
            type: 'error'
       })
 		}
})
},
//试题分析页面 题目列表
async getQuestionLose({ commit, state, getters},{classname} = {}){
  axios.$req({
    url:'index/stat.Teachana/getQuestionLose',
    method:'post',
    params:{
     item_id:state.projectid,
     school_name:state.schoolname,
     class:classname || state.timuclass,
     exam_id:state.examid,
    },
    success({data}){
      //console.log(data,'列表1')
      if(data!=''){
        for(let i=0; i<data.length; i++){
          if(data[i].datika_num.substring(1,0) =='客' ){
             data[i].type = 1;
          }else{
             data[i].type = 2;
          }
        }
        console.log(data)
        commit("setData",{
        	data:data,
        	field: 'timulist'
        });
        //////console.log(data[0].timu_id)
        commit("setData",{
        	data:data[0].timu_id,
        	field: 'timuid'
        });
        commit("setData",{
        	data:data[0].tihao,
        	field: 'nowdatika'
        });
        commit("setData",{
        	data:data[0].type,
        	field: 'timutype'
        });
      }else{
          commit("setData",{
          	data:'empty',
          	field: 'timulist'
          });
      }

     //题目信息
     axios.$req({
         url:'index/stat.Teachana/getQuestionInfo',
         method:'post',
         params:{
          timu_id:data[0].timu_id
         },
         success({data}){
           if(data !=''){
             data.xuanxiang = JSON.parse(data.xuanxiang)
             if(data.paper_img !=null && data.paper_img !=''){
               if(data.paper_img.indexOf(',')!=-1){
                 data.paper_img = data.paper_img.split(',')
               }else{
                  data.paper_img = data.paper_img.split()
               }
             }
             // QuestionInfo.datika_num.substring(1,0) ==
             if(data.answer_img !=null && data.answer_img !=''){
               if(data.answer_img.indexOf(',')!=-1){
                 data.answer_img = data.answer_img.split(',')
               }else{
                  data.answer_img = data.answer_img.split()
               }
             }
             // if(data.datika_num.substring(1,0) =='客' ){
             //    data.type = 1;
             // }else{
             //    data.type = 2;
             // }
             // console.log(data,'题')
           }

           commit("setData",{
           	data:data,
           	field: 'QuestionInfo'
           });

        },
 		fail({message}){
      if(deblug) return
       Message({
            message:'题目信息'+message,
            type: 'error'
       })
 		}
     })
     //试题情况
     axios.$req({
         url:'index/stat.Teachana/getAnalyQustion',
         method:'post',
         params:{
          item_id:state.projectid,
          school_name:state.schoolname,
          class:classname || state.timuclass,
          exam_id:state.examid,
          timu_id:data[0].timu_id
         },
         success({data}){
           data[0].avg = (Number(data[0].wrong_people)/Number(data[0].total_people)*100).toFixed(2)
           commit("setData",{
           	data:data[0],
           	field: 'timudefault'
           });
        },
 		fail({message}){
      if(deblug) return
       Message({
            message:'试题情况'+message,
            type: 'error'
       })
 		}
     })
     //各分段分布情况
     axios.$req({
         url:'index/stat.Teachana/getAnswerScore',
         method:'post',
         params:{
          item_id:state.projectid,
          class:state.moretimuclass,
          exam_id:state.examid,
          timu_id:data[0].timu_id
         },
         success({data}){
            //////console.log('分布3')
         let arr=[];
         for(let i in data){
           let obj = {
             class:i,
             list:[]
           }
            let score=[];//得分
           for(let j in data[i][0]){
             if(data[i][0][j].name_list.indexOf(',') !=-1){
               data[i][0][j].name_list = data[i][0][j].name_list.split(',')
             }else{
               data[i][0][j].name_list = data[i][0][j].name_list.split()
             }
             score.push({
               value:data[i][0][j].count,
               name:'得' + data[i][0][j].score+ '分',
               name_list:data[i][0][j].name_list
             })
           }
             obj.list = score;
             arr.push(obj)
         }
           commit("setData",{
           	data:arr,
           	field: 'AnswerScore'
           });
        },
 		fail({message}){
      if(deblug) return
       Message({
            message:'各分段分布情况'+message,
            type: 'error'
       })
 		}
     })
     //各分段分布情况
     axios.$req({
         url:'index/stat.Teachana/getAnswerType',
         method:'post',
         params:{
          item_id:state.projectid,
          class:state.moretimuclass,
          exam_id:state.examid,
          timu_id:data[0].timu_id
         },
         success({data}){
          let arr=[];
          for(let i in data){
            let obj = {
              class:i,
              list:[]
            }
             let score=[];//得分
            for(let j in data[i][0]){
              if(data[i][0][j].name_list.indexOf(',') !=-1){
                data[i][0][j].name_list = data[i][0][j].name_list.split(',')
              }else{
                data[i][0][j].name_list = data[i][0][j].name_list.split()
              }
              score.push({
                value:data[i][0][j].count,
                name:'选' + data[i][0][j].answer,
                name_list:data[i][0][j].name_list,
                score:data[i][0][j].score
              })
            }
              obj.list = score;
              arr.push(obj)
          }
           commit("setData",{
           	data:arr,
           	field: 'AnswerType'
           });
        },
 		fail({message}){
      if(deblug) return
       Message({
            message:'各分段分布情况'+message,
            type: 'error'
       })
 		}
     })
},
 		fail({message}){
      if(deblug) return
       Message({
            message:'题目列表'+message,
            type: 'error'
       })
 		}
})
},
//试题分析页面 题目情况
async getAnalyQustion({ commit, state, getters},{classname,timuid} = {}){
  axios.$req({
    url:'index/stat.Teachana/getAnalyQustion',
    method:'post',
    params:{
     item_id:state.projectid,
     school_name:state.schoolname,
     class:classname || state.moretimuclass,
     exam_id:state.examid,
     timu_id:timuid || state.timuid
    },
    success({data}){
       //////console.log('试题信息2')
      data[0].avg = (Number(data[0].wrong_people)/Number(data[0].total_people)*100).toFixed(2)
      commit("setData",{
      	data:data[0],
      	field: 'timudefault'
      });

   },
 		fail({message}){
      if(deblug) return
       Message({
            message:'题干'+message,
            type: 'error'
       })
 		}
})
}
,
//求单题目所有得分学生占比
async getAnswerScore({ commit, state, getters},{classname,timuid} = {}){
  axios.$req({
    url:'index/stat.Teachana/getAnswerScore',
    method:'post',
    params:{
     item_id:state.projectid,
     class:classname || state.moretimuclass,
     exam_id:state.examid,
     timu_id:timuid || state.timuid
    },
    success({data}){
      let arr=[];
      for(let i in data){
        let obj = {
          class:i,
          list:[]
        }
         let score=[];//得分
        for(let j in data[i][0]){
          if(data[i][0][j].name_list.indexOf(',') !=-1){
            data[i][0][j].name_list = data[i][0][j].name_list.split(',')
          }else{
            data[i][0][j].name_list = data[i][0][j].name_list.split()
          }
          score.push({
            value:data[i][0][j].count,
            name:'得' + data[i][0][j].score+ '分',
            name_list:data[i][0][j].name_list
          })
        }
          obj.list = score;
          arr.push(obj)
      }
      commit("setData",{
      	data:arr,
      	field:'AnswerScore'
      });
   },
 		fail({message}){
      if(deblug) return
       Message({
            message:'学生占比'+message,
            type: 'error'
       })
 		}
})
},
//求单题目所有得分学生选项
async getAnswerType({ commit, state, getters},{classname,timuid} = {}){
  axios.$req({
    url:'index/stat.Teachana/getAnswerType',
    method:'post',
    params:{
     item_id:state.projectid,
     class:classname || state.timuclass,
     exam_id:state.examid,
     timu_id:timuid || state.timuid
    },
    success({data}){
      console.log(data,12312)
      let arr=[];
      for(let i in data){
        let obj = {
          class:i,
          list:[]
        }
         let score=[];//得分
        for(let j in data[i][0]){
          if(data[i][0][j].name_list.indexOf(',') !=-1){
            data[i][0][j].name_list = data[i][0][j].name_list.split(',')
          }else{
            data[i][0][j].name_list = data[i][0][j].name_list.split()
          }
          score.push({
          value:data[i][0][j].count,
          name:'选' + data[i][0][j].answer,
          name_list:data[i][0][j].name_list,
          score:data[i][0][j].score
          })
        }
          obj.list = score;
          arr.push(obj)
      }
       commit("setData",{
       	data:arr,
       	field: 'AnswerType'
       });
   },
 		fail({message}){
      if(deblug) return
       Message({
            message:'学生占比'+message,
            type: 'error'
       })
 		}
})
},
//题目信息11
async getQuestionInfo({ commit, state, getters},{timuid} = {}){
  axios.$req({
    url:'index/stat.Teachana/getQuestionInfo',
    method:'post',
    params:{
     timu_id:timuid || state.timuid
    },
    success({data}){
      //////console.log(state.timuid)
      if(data !=''){
        data.xuanxiang = JSON.parse(data.xuanxiang)
        if(data.paper_img !=null && data.paper_img !=''){
          if(data.paper_img.indexOf(',')!=-1){
            data.paper_img = data.paper_img.split(',')
          }else{
             data.paper_img = data.paper_img.split()
          }
        }
        if(data.answer_img !=null && data.answer_img !=''){
          if(data.answer_img.indexOf(',')!=-1){
            data.answer_img = data.answer_img.split(',')
          }else{
             data.answer_img = data.answer_img.split()
          }
        }
      }
      commit("setData",{
      	data:data,
      	field: 'QuestionInfo'
      });

   },
 		fail({message}){
      if(deblug) return
       Message({
            message:'题目信息22'+message,
            type: 'error'
       })
 		}
})
},
//科目均衡对比
async getsubjectBalanced({commit,state,getter},{classname}={}){
     let classlist = state.calsslist.join(',')
  axios.$req({
    url:'index/stat.Teachana/allAvgCompare',
    method:'post',
    params:{
      item_id:state.projectid,
      school_name:state.schoolname,
      class:classname || classlist
    },
    success({data}){
      ////console.log(data)
      commit("setData",{
      	data:data,
      	field: 'allAvgCompare'
      });
    },
 		fail({message}){
      if(deblug) return
       Message({
            message:'科目均衡对比'+message,
            type: 'error'
       })
 		}
  })
},




}
export default action



// WEBPACK FOOTER //
// ./src/store/modules/analysis/action.js